import { Component, EventEmitter, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { detailExpand } from '../../../shared-components/angular-material/mat-animations';
import { AriaDirective } from '../../../shared-components/directives/aria.directive';
import { SharedService } from '../../../shared-components/shared.service';
import { Attendance } from '../../../shared-components/student/attendance.model';
import { LoginService } from '../../../shared-modules/login/login.service';

@Component({
  selector: 'by-date-table',
  templateUrl: './by-date-table.component.html',
  animations: [detailExpand],
})
export class ByDateTableComponent implements OnInit, OnDestroy {

  // ----------Angular Material------------------------------------
  angularMatData = new TylerMatTableDataSource();
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  columnsToDisplayAttend = ['More', 'AttendanceDay', 'AttendanceDate', 'Type', 'Duration', 'Codes', 'Days', 'Hours'];
  @Input() attendance: Attendance[];
  @Input() calendarUseAttendanceTypes: boolean;
  clearFilterEvent = new EventEmitter<any>();

  constructor(
    private sharedService: SharedService,
    private loginService: LoginService
  ) {
  }

  ngOnInit() {
    this.angularMatData.data = this.attendance;

    this.angularMatData.sort = this.sort;
  }

  ngOnDestroy() {
    // POST: ends all subscriptions
  }

  // ----------Angular Material------------------------------------
  toggleExpanded(row: any) {
    this.angularMatData.toggleExpanded(row);
  }

  checkExpanded(row: any): boolean {
    return this.angularMatData.checkExpanded(row);
  }

  expandAll(expand: boolean) {
    this.sharedService.updateShowSpinner(true);
    setTimeout(() => {
      this.angularMatData.expandAll(expand);
      this.sharedService.updateShowSpinner(false);
    }, 100);
  }

  rowKeyPress(event: KeyboardEvent, row: any) {
    this.angularMatData.rowKeyPress(event, row);

  }

  getAriaRowByDate(row: Attendance): string {
    const colList: string[] = ['Date',
      'Type',
      'Duration',
      'Codes'];

    const dataList: string[] = [new Date(row.AttendanceDate).toDateString(),
    row.Type,
    row.Duration,
    row.Codes];

    return AriaDirective.concatAriaStrings(colList, dataList) + (row.AttendanceDetails.length > 0 ? ' Expand for more details' : ' No additional details');
  }
}
